import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { Link, useNavigate } from "react-router-dom";
import S3Upload from "../S3Upload";

import styles from "../../App.module.css";
import { newApplication } from "../../lib/api";

const InputSubmission = () => {
  // eslint-disable-next-line no-unused-vars
  let navigate = useNavigate();

  const isAuth = useSelector((state) => state.user.isLoggedIn);
  const apid = useSelector((state) => state.user.accountId);

  /* TODO: validation on input fields, fill out post request */

  const [applicant_first_name, setApplicantFirstName] = useState("");
  const [applicant_last_name, setApplicantLastName] = useState("");
  const [applicant_email, setApplicantEmail] = useState("");
  const [applicant_degrees, setApplicantDegrees] = useState("");
  const [applicant_inst, setApplicantInst] = useState("");
  const [applicant_dept, setApplicantDept] = useState("");
  const [applicant_division, setApplicantDivision] = useState("");
  const [applicant_position, setApplicantPosition] = useState("");
  const [fellowship_program, setFellowshipProgram] = useState(null);
  const [fellowship_year, setFellowshipYear] = useState(null);
  const [fellowship_completion, setFellowshipCompletion] = useState(null);
  const [mentor_first_name, setMentorFirstName] = useState("");
  const [mentor_last_name, setMentorLastName] = useState("");
  const [mentor_degrees, setMentorDegrees] = useState("");
  const [mentor_email, setMentorEmail] = useState("");
  const [mentor_institution, setMentorInstitution] = useState("");
  const [mentor_department, setMentorDepartment] = useState("");
  const [mentor_division, setMentorDivision] = useState("");
  const [mentor_titles, setMentorTitles] = useState("");
  const [faculty_title, setFacultyTitle] = useState(null);
  const [funding_path, setFundingPath] = useState("");
  const [initial_proposal_file_s, setInitialProposalFile_s] = useState("");
  const [initial_proposal_file_c, setInitialProposalFile_c] = useState("");
  const [show_faculty, setShowFaculty] = useState(false);
  const [show_fellow, setShowFellow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [page_num, setPageNum] = useState(1);

  const render_type_field = (val) => {
    if (val === "Faculty") {
      setShowFaculty(true);
      setShowFellow(false);
      setFellowshipCompletion(null);
      setFellowshipProgram(null);
      setFellowshipYear(null);
    } else {
      setShowFaculty(false);
      setShowFellow(true);
      setFacultyTitle(null);
    }
    setApplicantPosition(val);
  };

  useEffect(() => {
    if (applicant_position) {
      render_type_field(applicant_position);
    }
  }, [applicant_position]);


  const sendEmail = async () => {

    const body_html = `<p>Dear ${applicant_first_name} ${applicant_last_name},</p>
      <p>Thank you for submitting your full proposal for the APA RAPID Scholar Awards.  Your application has been received and will be reviewed after all submissions have been collected.  You will be notified of the status of your application after the review period concludes.  We appreciate your patience as this can take several weeks.  If you have any questions, please contact the APA office at <a href="mailto:rapid@academicpeds.org">rapid@academicpeds.org</a>.</p>
      <p>Sincerely,</p>
      <p>The RAPID National Advisory Committee</p>`;
   
    try {
      const response = await fetch(`https://degnon-api.herokuapp.com/mail`, {
        method: 'POST',
        headers: {
            'Content-Type':'application/json',
            'awsKey': process.env.REACT_APP_AWS_ACCESS_KEY_ID
        },
        body: JSON.stringify({
            sender: 'info@academicpeds.org',
            recipient: applicant_email,
            bccEmail: ['info@academicpeds.org'],
            subject: 'APA RAPID Scholar Awards Full Proposal Application Received',
            body_html: body_html
        })
    });
   
    const responseData = await response;
   
    return responseData;
    }
    catch (ex) {
      return null;
    }
   
  }

  const validateForm = async () => {
    let valid = 1;
    let page_return = 0;

    if (!initial_proposal_file_s) {
      valid = 0;
      page_return = 3;
    }
  
    if (
      !mentor_degrees ||
      !mentor_department ||
      !mentor_division ||
      !mentor_email ||
      !mentor_first_name ||
      !mentor_institution ||
      !mentor_last_name ||
      !mentor_titles
    ) {
      valid = 0;
      page_return = 2;
    }

    if (
      !applicant_first_name ||
      !applicant_last_name ||
      !applicant_email ||
      !applicant_degrees ||
      !applicant_inst ||
      !applicant_dept ||
      !applicant_division ||
      !funding_path
    ) {
      valid = 0;
      page_return = 1;
    }
    if (applicant_position === "Faculty") {
      if (!faculty_title) {
        valid = 0;
        page_return = 1;
      }
    } else if (applicant_position === "Fellow") {
      if (!fellowship_completion || !fellowship_program || !fellowship_year) {
        valid = 0;
        page_return = 1;
      }
    } else {
      valid = 0;
      page_return = 1;
    }
    if (valid === 0) {
      setPageNum(page_return);
      return false;
    }
    return true;
  };

  const validateTest = async (e) => {
    e.preventDefault();
    const valid = await validateForm();
    if (valid === false) {
      setValidated(true);
      e.stopPropagation();
    } else {
      const subResp = await onSubmitForm();
      if (subResp) {
        await sendEmail();
        navigate("./thankyou");
      }
      else {
        alert("There was an error submitting your application! Please try again later. Please contact info@academicpeds.org to report this issue.");
      }
    }
  };

  const onSubmitForm = async () => {
    try {
      const body = [
        {
          name: "fname",
          type: "TEXT",
          value: applicant_first_name,
        },
        {
          name: "lname",
          type: "TEXT",
          value: applicant_last_name,
        },
        {
          name: "email",
          type: "TEXT",
          value: applicant_email,
        },
        {
          name: "degree",
          type: "TEXT",
          value: applicant_degrees,
        },
        {
          name: "inst",
          type: "TEXT",
          value: applicant_inst,
        },
        {
          name: "department",
          type: "TEXT",
          value: applicant_dept,
        },
        {
          name: "division",
          type: "TEXT",
          value: applicant_division,
        },
        {
          name: "position",
          type: "TEXT",
          value: applicant_position,
        },
        {
          name: "mentfname",
          type: "TEXT",
          value: mentor_first_name,
        },
        {
          name: "mentlname",
          type: "TEXT",
          value: mentor_last_name,
        },
        {
          name: "mentdegree",
          type: "TEXT",
          value: mentor_degrees,
        },
        {
          name: "mentemail",
          type: "TEXT",
          value: mentor_email,
        },
        {
          name: "mentinst",
          type: "TEXT",
          value: mentor_institution,
        },
        {
          name: "mentdepartment",
          type: "TEXT",
          value: mentor_department,
        },
        {
          name: "mentdivision",
          type: "TEXT",
          value: mentor_division,
        },
        {
          name: "menttitle",
          type: "TEXT",
          value: mentor_titles,
        },
        {
          name: "fundpathsec",
          type: "TEXT",
          value: funding_path,
        },
        {
          name: "propfile_s",
          type: "TEXT",
          value: initial_proposal_file_s,
        },
        {
          name: "propfile_c",
          type: "TEXT",
          value: initial_proposal_file_c,
        },
        {
          name: "dues_year",
          type: "INT",
          value: 2024,
        },
        {
          name: "proposal_type",
          type: "TEXT",
          value: "full",
        },
      ];
      if (applicant_position === "Faculty") {
        body.push({
          name: "facultytitle",
          type: "TEXT",
          value: faculty_title,
        });
      } else {
        body.push(
          {
            name: "fellowshipyear",
            type: "TEXT",
            value: fellowship_year,
          },
          {
            name: "fellowshipcompletion",
            type: "TEXT",
            value: fellowship_completion,
          },
          {
            name: "fellowshipprogram",
            type: "TEXT",
            value: fellowship_program,
          }
        );
      }
      if (apid !== 0) {
        body.push({
          name: "apid",
          type: "INT",
          value: apid,
        });
      }
      const response = await newApplication(body);
      console.log(response);
      return response;
    } catch (err) {
      console.log("error here");
      console.error(err.message);
    }
  };

  return (
    <Fragment>
      <Card className={styles.Card}>
        <Card body className={styles["CardLvl2"]}>
          <Card.Title className={styles["page-header"]}>
            RAPID Scholar Award Full Proposal Application
          </Card.Title>
          <Link to="/">
            <Button type="button" className={styles["btn-round"]}>
              To Home
            </Button>
          </Link>
        </Card>
      </Card>
      <Card className={styles.Card}>
        <Card body className={styles["CardLvl2"]}>
          <Card.Title className={styles["sectionHeader"]}>
            Application Instructions
          </Card.Title>
          <Card.Body>
            <Card.Text>
              Please carefully review the following steps <em>before</em>{" "}
              submitting a Full Proposal:
            </Card.Text>
            <Card.Text>
              <ul>
                <li>Select one Funding Path</li>
                <li>
                  Ensure you meet the eligibility requirements for a RAPID Scholar
                </li>
                <li>
                Confirm that both you and your chosen mentors are current
                members of the{" "}
                <a
                  href="https://www.academicpeds.org/about/join-apa/"
                  target="_blank"
                >
                  Academic Pediatric Association
                </a>{" "}
                or{" "}
                <a
                  href="https://www.academicpeds.org/program/rapid/"
                  target="_blank"
                >
                  other supporting organization, based on selected funding path
                </a>{" "}
                  (If applying for the NIDDK pathway, confirm that both you and your chosen mentor(s) are current members of the Academic Pediatric Association; if applying for the PIDS pathway, confirm that both you and your chosen mentor(s) are current members of PIDS; for the ABP, APS, and Mead Johnson pathways, membership in an academic society is not required)
              </li>
              </ul>
            </Card.Text>
            <Card.Text>
              Please note: Applications cannot be partially completed and saved.
              Make sure you are prepared to complete and submit the entire application.
            </Card.Text>
          </Card.Body>
        </Card>
      </Card>
      {/* TODO: Change to react-bootstrap and flexbox */}
      <Form noValidate validated={validated} onSubmit={validateTest}>
        {page_num === 1 && (
          <Card className={styles.Card}>
            <Card className={[styles.CardLvl2, styles.bl]}>
              <Card.Title className={styles.sectionHeader}>
                Applicant Information
              </Card.Title>
            </Card>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Card.Title>
                Please select the funding path for which you are submitting a
                proposal
              </Card.Title>
              <Card.Body className={styles["flex-wrapper-vert"]}>
                <Form.Check
                  required
                  type="radio"
                  value={"NIDDK"}
                  id="NIDDK"
                  label={
                    "Nutrition, Obesity, Sickle Cell Disease, or other general pediatrics domain (Supported by the National Institute of Diabetes and Digestive and Kidney Diseases [NIDDK])"
                  }
                  name="path"
                  onChange={(e) => setFundingPath(e.target.value)}
                  checked={funding_path === "NIDDK"}
                />
                <Form.Check type="radio" id="APS">
                  <Form.Check.Input
                    required
                    type="radio"
                    value="APS"
                    name="path"
                    onChange={(e) => setFundingPath(e.target.value)}
                    checked={funding_path === "APS"}
                  />

                  <Form.Check.Label>
                    Pediatric basic, clinical, translational, or health services
                    research in any pediatric subspecialty (supported by the
                    American Pediatric Society [APS])
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio" id="Mead Johnson">
                  <Form.Check.Input
                    required
                    type="radio"
                    value="Mead Johnson"
                    name="path"
                    onChange={(e) => setFundingPath(e.target.value)}
                    checked={funding_path === "Mead Johnson"}
                  />

                  <Form.Check.Label>
                    Neonatal Nutrition (Supported by Reckitt/Mead Johnson)
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio" id="PIDS">
                  <Form.Check.Input
                    required
                    type="radio"
                    value={"PIDS"}
                    name="path"
                    onChange={(e) => setFundingPath(e.target.value)}
                    checked={funding_path === "PIDS"}
                  />

                  <Form.Check.Label>
                    Pediatric Infectious Disease (Supported by the Pediatric
                    Infectious Diseases Society (PIDS))
                  </Form.Check.Label>
                </Form.Check>
                <Form.Check type="radio" id="ABP">
                  <Form.Check.Input
                    required
                    type="radio"
                    value={"ABP"}
                    name="path"
                    onChange={(e) => setFundingPath(e.target.value)}
                    checked={funding_path === "ABP"}
                  />

                  <Form.Check.Label>
                    Behavioral Mental Health / Health Equity (Supported by the
                    American Board of Pediatrics (ABP) Foundation)
                  </Form.Check.Label>
                </Form.Check>
              </Card.Body>
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Applicant First Name</Form.Label>
              <Form.Control
                required
                type="text"
                value={applicant_first_name}
                onChange={(e) => setApplicantFirstName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={styles["CardLvl2"]}>
              <Form.Label as={Card.Title}>Applicant Last Name</Form.Label>
              <Form.Control
                required
                type="text"
                value={applicant_last_name}
                onChange={(e) => setApplicantLastName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={styles["CardLvl2"]}>
              <Form.Label as={Card.Title}>
                Applicant Preferred Email Address
              </Form.Label>
              <Form.Control
                required
                type="email"
                value={applicant_email}
                onChange={(e) => setApplicantEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={styles["CardLvl2"]}>
              <Form.Label as={Card.Title}>Applicant Degree(s)</Form.Label>
              <Form.Control
                required
                type="text"
                value={applicant_degrees}
                onChange={(e) => setApplicantDegrees(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={styles["CardLvl2"]}>
              <Form.Label as={Card.Title}>Applicant Institution</Form.Label>
              <Form.Control
                required
                type="text"
                value={applicant_inst}
                onChange={(e) => setApplicantInst(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={styles["CardLvl2"]}>
              <Form.Label as={Card.Title}>Applicant Department</Form.Label>
              <Form.Control
                required
                type="text"
                value={applicant_dept}
                onChange={(e) => setApplicantDept(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={styles["CardLvl2"]}>
              <Form.Label as={Card.Title}>Applicant Division</Form.Label>
              <Form.Control
                required
                type="text"
                value={applicant_division}
                onChange={(e) => setApplicantDivision(e.target.value)}
              />
            </Form.Group>
            <Form.Group
              as={Card}
              body
              className={[styles["CardLvl2"], styles["bl"]]}
            >
              <Card.Title>
                Please select the option that best fits your current position
              </Card.Title>
              <Card.Body className={styles["flex-wrapper-vert"]}>
                <Form.Check
                  required
                  type="radio"
                  value={"Faculty"}
                  id="Faculty"
                  checked={show_faculty === true}
                  label={"Faculty"}
                  name="position"
                  onChange={(e) => render_type_field(e.target.value)}
                />
                <Form.Check
                  required
                  type="radio"
                  value={"Fellow"}
                  id="Fellow"
                  checked={show_fellow === true}
                  label={"Fellow"}
                  name="position"
                  onChange={(e) => render_type_field(e.target.value)}
                />
              </Card.Body>
            </Form.Group>
            {show_fellow && (
              <Card
                body
                className={[styles["CardLvl2"], styles["flex-wrapper-vert"]]}
              >
                <Card.Title className={styles["sectionHeader"]}>
                  Fellowship Information
                </Card.Title>
                <Card.Body className={styles["flex-wrapper-vert"]}>
                  <Form.Group>
                    <Form.Label as={Card.Title}>Type of Program</Form.Label>
                    <Form.Control
                      required={show_fellow}
                      type="text"
                      value={fellowship_program || ""}
                      onChange={(e) => setFellowshipProgram(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label as={Card.Title}>Year in Program</Form.Label>
                    <Form.Control
                      required={show_fellow}
                      type="number"
                      value={fellowship_year || ""}
                      onChange={(e) => setFellowshipYear(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label as={Card.Title}>
                      Anticipated Completion Date (if 2025, please submit a
                      brief statement on post-training completion plans)
                    </Form.Label>
                    <Form.Control
                      required={show_fellow}
                      type="text"
                      value={fellowship_completion || ""}
                      onChange={(e) => setFellowshipCompletion(e.target.value)}
                    />
                  </Form.Group>
                </Card.Body>
              </Card>
            )}
            {show_faculty && (
              <Card
                body
                className={[styles["CardLvl2"], styles["flex-wrapper-vert"]]}
              >
                <Card.Title className={styles["sectionHeader"]}>
                  Faculty Information
                </Card.Title>
                <Form.Group>
                  <Form.Label as={Card.Title}>
                    Please specify your title(s)
                  </Form.Label>
                  <Form.Control
                    required={show_faculty}
                    type="text"
                    value={faculty_title || ""}
                    onChange={(e) => setFacultyTitle(e.target.value)}
                  />
                </Form.Group>
              </Card>
            )}
            <Card body className={[styles["CardLvl2"], styles["bl"]]}>
              <Button
                type="button"
                className={styles["btn-round"]}
                onClick={() => setPageNum(2)}
              >
                Next
              </Button>
            </Card>
          </Card>
        )}
        {page_num === 2 && (
          <Card className={styles["Card"]}>
            <Card className={[styles.CardLvl2, styles.bl]}>
              <Card.Title className={styles.sectionHeader}>
                Primary Mentor Information
              </Card.Title>
            </Card>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Primary Mentor First Name</Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_first_name}
                onChange={(e) => setMentorFirstName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Primary Mentor Last Name</Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_last_name}
                onChange={(e) => setMentorLastName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Primary Mentor Degree(s)</Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_degrees}
                onChange={(e) => setMentorDegrees(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>
                Primary Mentor Preferred Email Address
              </Form.Label>
              <Form.Control
                required
                type="email"
                value={mentor_email}
                onChange={(e) => setMentorEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>
                Primary Mentor Institution
              </Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_institution}
                onChange={(e) => setMentorInstitution(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Primary Mentor Department</Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_department}
                onChange={(e) => setMentorDepartment(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Primary Mentor Division</Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_division}
                onChange={(e) => setMentorDivision(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Card} body className={[styles["CardLvl2"]]}>
              <Form.Label as={Card.Title}>Primary Mentor Title(s)</Form.Label>
              <Form.Control
                required
                type="text"
                value={mentor_titles}
                onChange={(e) => setMentorTitles(e.target.value)}
              />
            </Form.Group>
            <Card body className={[styles["CardLvl2"]]}>
              <Card.Body className={styles["flex-wrapper-between"]}>
                <Button
                  type="button"
                  className={styles["btn-round"]}
                  onClick={() => setPageNum(1)}
                >
                  Previous
                </Button>
                <Button
                  type="button"
                  className={styles["btn-round"]}
                  onClick={() => setPageNum(3)}
                >
                  Next
                </Button>
              </Card.Body>
            </Card>
          </Card>
          )}
          {page_num === 3 && (
          <Card className={styles["Card"]}>
            <Card className={[styles.CardLvl2, styles.bl]}>
              <Card.Title className={styles.sectionHeader}>
                Proposal Upload
              </Card.Title>
            </Card>
          <Card body className={styles["CardLvl2"]}>
            <Card.Title>Submit Your Full Proposal</Card.Title>
            <Card.Text>Please be sure to review the <a href="https://www.academicpeds.org/wp-content/uploads/2024/12/APA-RAPID-Full-Proposal-Application-Checklist.pdf" target="_blank">Full Proposal Checklist</a> for detailed application instructions prior to submitting.</Card.Text>
            <Card.Body>
              Current File:{" "}
              {initial_proposal_file_c ? (
                <a
                  href={initial_proposal_file_s}
                  target="_blank"
                  rel="noreferrer"
                >
                  {initial_proposal_file_c}
                </a>
              ) : (
                "No file uploaded"
              )}
            </Card.Body>
            <Card.Body>
              <S3Upload
                updateFn_s={setInitialProposalFile_s}
                updateFn_c={setInitialProposalFile_c}
              />
            </Card.Body>
          </Card>
          <Card body className={[styles["CardLvl2"]]}>
            <Card.Body className={styles["flex-wrapper-between"]}>
              <Button
                type="button"
                className={styles["btn-round"]}
                onClick={() => setPageNum(2)}
              >
                Previous
              </Button>
              <Button
                type="submit"
                className={styles["btn-round"]}
                variant="secondary"
              >
                Submit
              </Button>
            </Card.Body>
          </Card>
        </Card>
        )}
      </Form>
    </Fragment>
  );
};

export default InputSubmission;
